import { combineReducers } from 'redux';

import registrant from './registrant';
import registrants from './registrants';

export default combineReducers({
    registrant,
    registrants
});
